// client/src/api/ApiChat.js
import flex from './FlexFetch'
import { unwrapStrictData } from './contractUtils'

function flattenStrictObjectPayload(payload) {
  const data = unwrapStrictData(payload)

  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return data
  }

  if (
    payload?.success === true &&
    Object.prototype.hasOwnProperty.call(payload, 'data')
  ) {
    return {
      ...payload,
      ...data,
    }
  }

  return data
}

async function getChannels() {
  const response = await flex.flexFetch('/api/1.0/chat/getChannels')
  return flattenStrictObjectPayload(await flex.handleResponse(response))
}

async function getMessages(channelId, before = null, limit = 50) {
  const params = new URLSearchParams({
    channelId: channelId.toString(),
    limit: limit.toString(),
  })

  if (before) {
    params.append('before', before)
  }

  const url = `/api/1.0/chat/getMessages?${params.toString()}`

  const response = await flex.flexFetch(url)
  return flattenStrictObjectPayload(await flex.handleResponse(response))
}

async function sendMessage(channelId, body) {
  const response = await flex.flexFetch('/api/1.0/chat/sendMessage', {
    method: 'POST',
    body: JSON.stringify({ channelId, body }),
  })
  return flattenStrictObjectPayload(await flex.handleResponse(response))
}

async function joinDivisionChannels() {
  const response = await flex.flexFetch('/api/1.0/chat/joinDivisionChannels', {
    method: 'POST',
  })
  return flattenStrictObjectPayload(await flex.handleResponse(response))
}

async function joinLeagueChannels() {
  const response = await flex.flexFetch('/api/1.0/chat/joinLeagueChannels', {
    method: 'POST',
  })
  return flattenStrictObjectPayload(await flex.handleResponse(response))
}

async function startDirectMessage(opponentPlayerId, divisionId) {
  const response = await flex.flexFetch('/api/1.0/chat/startDirectMessage', {
    method: 'POST',
    body: JSON.stringify({
      opponent_player_id: opponentPlayerId,
      division_id: divisionId,
    }),
  })
  return flattenStrictObjectPayload(await flex.handleResponse(response))
}

async function editMessage(messageId, body) {
  const response = await flex.flexFetch('/api/1.0/chat/editMessage', {
    method: 'POST',
    body: JSON.stringify({ messageId, body }),
  })
  return flattenStrictObjectPayload(await flex.handleResponse(response))
}

async function deleteMessage(messageId) {
  const response = await flex.flexFetch('/api/1.0/chat/deleteMessage', {
    method: 'POST',
    body: JSON.stringify({ messageId }),
  })
  return flattenStrictObjectPayload(await flex.handleResponse(response))
}

async function getOnlineUsers(channelId) {
  const params = new URLSearchParams({
    channelId: channelId.toString(),
  })

  const url = `/api/1.0/chat/getOnlineUsers?${params.toString()}`
  const response = await flex.flexFetch(url)
  return flattenStrictObjectPayload(await flex.handleResponse(response))
}

const ApiChat = {
  getChannels,
  getMessages,
  sendMessage,
  joinDivisionChannels,
  joinLeagueChannels,
  startDirectMessage,
  editMessage,
  deleteMessage,
  getOnlineUsers,
}

export default ApiChat
